import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import brandingStyles from '../branding/brandingStyles';

// Display a small illustration for confirmation on group actions
class GroupIllustrationComponent extends Component {

    getUserRow(user) {
        const styles = {
            row: {
                display: 'block',
            },
        };

        return (
            <span key={user} style={styles.row}>
                <i className="fa fa-user" style={brandingStyles.mainColor}></i>
                &nbsp; {user}
            </span>
        );
    }

    getIconCode() {
        return (`fa fa-${this.props.icon}`);
    }

    render() {
        const styles = {
            container: {
                fontSize: '20px',
            },
            list: {
                maxHeight: '200px',
                overflowY: 'scroll',
            },
        };

        const usersList = this.props.users.map(user => this.getUserRow(user));

        return (
            <div style={styles.container}>
                <div className="col-md-offset-1 col-md-4"
                  style={styles.list}>
                    {usersList}
                </div>
                <div className="col-md-2">
                    <i className={this.getIconCode()}
                      style={brandingStyles.mainColor}></i>
                </div>
                <div className="col-md-4">
                    <span>
                        <i className="fa fa-users"
                          style={brandingStyles.mainColor}></i>
                        &nbsp; {this.props.groupname}
                    </span>

                </div>
                <div style={{
                    clear: 'both',
                }}></div>
            </div>
        );
    }
}

GroupIllustrationComponent.propTypes = {
    users: PropTypes.array.isRequired,
    groupname: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
};

export default GroupIllustrationComponent;



/** WEBPACK FOOTER **
 ** ./src/components/GroupIllustration.js
 **/